import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { handleIncentivePost } from '../../commonHandlerFunction/Feedback/IncentiveHandler';
import { toast } from 'react-toastify';

const IncentiveButton = ({ formData, setIsOverlayLoader, viewOnly }) => {
    const navigate = useNavigate();
    return (
        <div className="auditBtns">
            <Button
                type="button"
                className="cancelBtn"
                onClick={() => navigate("/incentivesList")}
            >
                Back
            </Button>
            {
                !viewOnly && formData[0]?.incentive_status !== 1 &&
                <Button
                    type="button"
                    className="submitBtn"
                    onClick={() => {
                        if (formData[0]?.incentive_jobcosting) {
                            handleIncentivePost(
                                formData,
                                setIsOverlayLoader,
                                navigate
                            )
                        } else {
                            toast.error("You must have complete Job Costing Flow", {
                                position: "top-right",
                                autoClose: 2000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        }
                    }}
                >
                    <span>Post</span>
                </Button>
            }
        </div>
    )
}

export default IncentiveButton
